export class FundingInformationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFundingInformation({ loanId }) {
    return this.#http.get(`/loan/${loanId}/funding`);
  }

  async editFundingInformation({ loanId, body, ...params }) {
    return this.#http.put(`/loan/${loanId}/funding`, body, { params });
  }
}
